import { ArrowRight, CalendarClockIcon, CarIcon } from 'assets/icons';
import useText from 'hooks/useText';
import { roadLabel } from 'pages/planning/planningItems';

// What is done of what was planned, a line and its bar each.

// « Semaine de Fabien », « Semaine d’Anne »: the French elision before a vowel.
const weekOf = (name) => (/^[aeiouyhàâéèêëîïôöûü]/i.test(name) ? `Semaine d’${name}` : `Semaine de ${name}`);
const PROGRESS = ['events', 'tasks', 'calls'];

/**
 * « Ma semaine », beside the planning: the visits still to place (a red card
 * that opens them), then the appointments held, the tasks done and the calls
 * answered of the week, and the road it takes. `ownerName`: the colleague
 * whose week a manager looks at (« Semaine de Fabien »).
 */
const WeekPanel = ({ label, ownerName, toPlace, stats, onPlace }) => {
  const { text } = useText('planning');
  return (
    <aside className="flex w-[343px] shrink-0 flex-col gap-4 overflow-y-auto rounded-2xl border border-gray-100 bg-white p-4">
      <div>
        <p className="ft-b font-semibold text-gray-900">{ownerName ? weekOf(ownerName) : text('myWeek')}</p>
        <p className="text-xs text-gray-400">{label}</p>
      </div>
      {toPlace > 0 && (
        <button type="button" onClick={onPlace} className="flex items-center gap-3 rounded-2xl bg-red-50 p-4 text-left transition-colors hover:bg-red-100">
          <span className="min-w-0 flex-1">
            <span className="block ft-lg font-semibold leading-6 text-gray-900">
              {text(toPlace > 1 ? 'toPlaceMany' : 'toPlaceOne', { count: toPlace })}
            </span>
            <span className="mt-2 flex items-center gap-2 text-sm font-medium text-red-700">
              {text('placeVisits')} <ArrowRight wh={18} color="currentColor" />
            </span>
          </span>
          <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-red-100 text-red-700">
            <CalendarClockIcon wh={22} color="currentColor" />
          </span>
        </button>
      )}
      <div className="flex flex-col gap-4 rounded-2xl border border-gray-100 p-4">
        {PROGRESS.map((key, index) => {
          const { done, total } = stats[key];
          return (
            <div key={key}>
              <p className="flex items-baseline justify-between gap-3">
                <span className="text-sm font-medium text-gray-700">{text(`progress_${key}`)}</span>
                <span>
                  <span className="ft-b font-semibold text-gray-900">{done}</span>
                  {total > 0 && <span className="text-sm text-gray-600">/{total}</span>}
                </span>
              </p>
              <div className="mt-2 h-1.5 overflow-hidden rounded-full bg-gray-100">
                <div
                  className="h-full origin-left rounded-full bg-emerald-500 motion-safe:animate-barGrow"
                  style={{ width: `${total ? (done / total) * 100 : 0}%`, animationDelay: `${index * 120}ms` }}
                />
              </div>
            </div>
          );
        })}
        <p className="flex items-center gap-2 border-t border-gray-100 pt-4 text-sm text-gray-600">
          <span className="flex shrink-0 text-gray-400">
            <CarIcon wh={16} color="currentColor" />
          </span>
          <span>
            <span className="font-semibold text-gray-900">{roadLabel(stats.road)}</span> {text('roadEstimated')}
          </span>
        </p>
      </div>
    </aside>
  );
};

export default WeekPanel;
